module.exports = __webpack_public_path__ + "img/ExhibitionView2.1bce0354.jpg";